// extracted by mini-css-extract-plugin
module.exports = {"container":"columnData_container__y5_ZK","head":"columnData_head__KCpfz","text":"columnData_text__81IQu"};